export default __webpack_public_path__ + "static/media/Payroll.62c87e65.svg";